// GRAFT: generic handler for "direct buy" plan-card forms (homepage and
// product page). Each form posts straight to /cart/add and redirects via its
// own return_to — this works with no JS at all. This script only adds two
// progressive enhancements where JS is available:
//   1. A loading state on the button, to stop double-taps.
//   2. Optionally (data-graft-clear-first), clearing the cart before adding,
//      so a customer can't end up with two different plans in the same cart.
// Without JS, forms still submit and redirect correctly — clearing just
// doesn't happen, which only matters if the customer already added a
// different plan in the same session.

(function () {
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches || !form.matches('[data-graft-direct-buy]')) return;

    var button = form.querySelector('button[type="submit"]');
    var label = form.querySelector('.graft-plan-card__button-label');
    var loading = form.querySelector('.graft-plan-card__button-loading');

    if (button && button.disabled) {
      // Already submitting — ignore a second tap.
      event.preventDefault();
      return;
    }

    if (button) button.disabled = true;
    if (label) label.hidden = true;
    if (loading) loading.hidden = false;

    if (!form.hasAttribute('data-graft-clear-first')) {
      // No clearing needed — let the form submit natively, no JS required.
      return;
    }

    event.preventDefault();

    fetch('/cart/clear.js', { method: 'POST' })
      .catch(function () {})
      .then(function () {
        form.submit();
      });
  });
})();
